/* Collection Main Grid Premium - shared asset */
(function() {
  var cmgpCartPricingQueue = [];
  var cmgpCartPricingActive = 0;
  var CMGP_CART_PRICING_MAX = 2;

  function cmgpFormatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents);
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function cmgpPricingFromCartLine(line) {
    if (!line) return null;
    var original = line.original_price;
    var final = line.final_price;
    if (!original || final >= original) return null;
    return { onSale: true, original: original, final: final };
  }

  function cmgpFetchVariantCartPricing(variantId) {
    return Promise.resolve(null);
  }

  function isGridSectionRoot(el) {
    if (!el || !el.classList || !el.classList.contains('collection-main-grid-premium')) return false;
    if (el.classList.contains('cmfc-bar')) return false;
    var sid = el.getAttribute('data-section-id');
    return !!(sid && document.getElementById('cmgp-grid-' + sid));
  }

  window.__cmgpGridBooted = window.__cmgpGridBooted || {};

  function bootCollectionGrid(attempt) {
    attempt = attempt || 0;
    var bootedAny = false;
    document.querySelectorAll('.collection-main-grid-premium[data-section-id]').forEach(function(sectionRoot) {
      if (!isGridSectionRoot(sectionRoot)) return;
      var bootSid = sectionRoot.getAttribute('data-section-id');
      if (!bootSid || window.__cmgpGridBooted[bootSid]) return;
      window.__cmgpGridBooted[bootSid] = true;
      sectionRoot.dataset.cmgpBooted = 'true';
      runCollectionGrid(sectionRoot);
      bootedAny = true;
    });
    if (!bootedAny && attempt < 40) {
      window.setTimeout(function() { bootCollectionGrid(attempt + 1); }, 100);
    }
  }

  function runCollectionGrid(sectionRoot) {
    const sectionId = sectionRoot.getAttribute('data-section-id');
    const wrapper = sectionRoot;
    const grid = document.getElementById('cmgp-grid-' + sectionId);
    /* Captured once at boot: sidebar FILTER uses full page reload with ?filter.* in URL. */
    var initialStorefrontFiltered = (function() {
      var s = (window.location && window.location.search) || '';
      if (s.charAt(0) === '?') s = s.slice(1);
      var q = new URLSearchParams(s);
      var found = false;
      q.forEach(function(val, key) {
        if (key.indexOf('filter.') === 0) found = true;
      });
      return found;
    })();
    const filterToggle = document.getElementById('cmgp-filter-toggle-' + sectionId);
    const filterOverlay = document.getElementById('cmgp-filter-overlay-' + sectionId);
    const filterClose = document.getElementById('cmgp-filter-close-' + sectionId);

    /* Category carousel: default first category + click = related products (no reload) */
    const carousel = document.getElementById('cmgp-carousel-' + sectionId);
    const replaceable = document.getElementById('cmgp-replaceable-content-' + sectionId);
    if (carousel && wrapper && replaceable) {
      const track = carousel.querySelector('.cmgp-carousel-track');
      const prevBtn = carousel.querySelector('.cmgp-carousel-prev');
      const nextBtn = carousel.querySelector('.cmgp-carousel-next');
      const items = carousel.querySelectorAll('.cmgp-carousel-item');
      var norm = function(v) { return (v || '').replace(/\+/g, ' ').toLowerCase().replace(/\s+/g, '-'); };
      var carouselRequestToken = 0;
      var carouselAbortController = null;

      function scrollToProductsGrid() {
        var gridEl = document.getElementById('cmgp-grid-' + sectionId);
        if (!gridEl) {
          var replaceableEl = document.getElementById('cmgp-replaceable-content-' + sectionId);
          if (replaceableEl) gridEl = replaceableEl.querySelector('.cmgp-grid');
        }
        if (gridEl && typeof gridEl.scrollIntoView === 'function') {
          gridEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        var replaceableFallback = document.getElementById('cmgp-replaceable-content-' + sectionId);
        if (replaceableFallback && typeof replaceableFallback.scrollIntoView === 'function') {
          replaceableFallback.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      function applyCarouselFilter(filterValue, param, updateHistory) {
        if (!filterValue || !param) return;
        var url = new URL(window.location.href);
        var filterNorm = norm(filterValue);
        var current = url.searchParams.getAll(param);
        var isActive = current.some(function(v) { return norm(v) === filterNorm; });

        /* Carousel: one filter at a time. Remove all carousel params then set only one if activating. */
        var carouselParams = ['filter.p.product_type', 'filter.p.tag', 'filter.p.m.custom.type'];
        carouselParams.forEach(function(p) { url.searchParams.delete(p); });

        if (isActive) {
          /* Clicked active filter again = show all (no carousel filter). */
          if (grid) grid.dataset.lastClickedFilters = '';
        } else {
          /* Activate only this filter - single value only. */
          url.searchParams.set(param, filterValue);
          if (grid) grid.dataset.lastClickedFilters = param + '::' + filterNorm;
        }

        url.searchParams.delete('sections');
        url.searchParams.delete('section_id');
        var qs = url.searchParams.toString();
        var go = url.pathname + (qs ? '?' + qs : '');
        /* URL we just built — always use this for filtering. Some browsers keep location.search stale briefly after pushState, so reading location alone can show "no filter" and all products stay visible. */
        var appliedSearch = url.search || '';

        /* Fetch full collection HTML (no storefront tag/type filter) so grid is not empty when
           Shopify's filtered URL returns 0 products but items still match client-side tags. */
        var fetchUrlObj = new URL(window.location.href);
        carouselParams.forEach(function(p) { fetchUrlObj.searchParams.delete(p); });
        fetchUrlObj.searchParams.delete('sections');
        fetchUrlObj.searchParams.delete('section_id');
        var fetchQs = fetchUrlObj.searchParams.toString();
        var fetchGo = fetchUrlObj.pathname + (fetchQs ? '?' + fetchQs : '');

        // Instant feedback: update URL + local grid filtering first, then sync HTML in background.
        if (updateHistory) {
          window.history.pushState({}, '', go);
        }
        updateCarouselActiveState(appliedSearch);
        if (typeof applyClientSideTypeFilter === 'function') applyClientSideTypeFilter(appliedSearch);
        scrollToProductsGrid();

        var requestToken = ++carouselRequestToken;
        if (carouselAbortController) carouselAbortController.abort();
        carouselAbortController = ('AbortController' in window) ? new AbortController() : null;

        fetch(fetchGo, {
          headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
          signal: carouselAbortController ? carouselAbortController.signal : undefined
        })
          .then(function(r) { return r.text(); })
          .then(function(html) {
            if (requestToken !== carouselRequestToken) {
              return;
            }
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var nextReplaceable = doc.getElementById('cmgp-replaceable-content-' + sectionId);
            if (!nextReplaceable) {
              window.location.href = go;
              return;
            }
            replaceable.innerHTML = nextReplaceable.innerHTML;
            updateCarouselActiveState(appliedSearch);
            if (typeof window.initCmgpCollectionPricing === 'function') {
              window.initCmgpCollectionPricing(sectionId);
            }
            var replacedGrid = document.getElementById('cmgp-grid-' + sectionId);
            if (replacedGrid && typeof applyInitialClientPagination === 'function') applyInitialClientPagination(replacedGrid, appliedSearch);
            if (typeof applyClientSideTypeFilter === 'function') applyClientSideTypeFilter(appliedSearch);
            if (typeof markWishlistActive === 'function') markWishlistActive();
            var done = (typeof autoLoadAllPagesIfFiltered === 'function')
              ? autoLoadAllPagesIfFiltered(appliedSearch)
              : Promise.resolve();
            return Promise.resolve(done).then(function() {
              if (typeof applyClientSideTypeFilter === 'function') applyClientSideTypeFilter(appliedSearch);
            });
          })
          .catch(function(err) {
            if (err && err.name === 'AbortError') return;
            window.location.href = go;
          });
      }

      function updateCarouselActiveState(optSearch) {
        var raw = optSearch !== undefined && optSearch !== null ? optSearch : (window.location && window.location.search) || '';
        var qStr = String(raw);
        if (qStr.charAt(0) === '?') qStr = qStr.slice(1);
        var q = new URLSearchParams(qStr);
        carousel.querySelectorAll('.cmgp-carousel-item').forEach(function(b) {
          var bparam = b.dataset.filterParam || 'filter.p.product_type';
          var bval = b.dataset.filterValue;
          var active = q.getAll(bparam).some(function(v) { return norm(v) === norm(bval); });
          b.classList.toggle('active', !!active);
        });
      }

      function ensureCarouselImagesFromAllPages() {
        var collHandle = (wrapper && wrapper.dataset && wrapper.dataset.collectionHandle) ? wrapper.dataset.collectionHandle : '';
        if (!collHandle) return;

        var carouselFilterTags = [];
        var allButtons = Array.from(carousel.querySelectorAll('.cmgp-carousel-item'));
        allButtons.forEach(function(btn) {
          var fv = norm(btn.dataset.filterValue || '');
          if (fv && carouselFilterTags.indexOf(fv) === -1) carouselFilterTags.push(fv);
        });

        var usedProductIds = {};
        var usedImageSrcs = {};
        function srcKey(src) { return (src || '').split('?')[0]; }

        function markUsed(btn, productId, imgSrc) {
          if (productId) usedProductIds[String(productId)] = true;
          if (imgSrc) usedImageSrcs[srcKey(imgSrc)] = true;
          if (btn && productId) btn.setAttribute('data-carousel-product-id', String(productId));
        }

        var pending = {};
        var seenSrcOwner = {};
        allButtons.forEach(function(btn) {
          var key = (btn.dataset.filterParam || 'filter.p.tag') + '::' + norm(btn.dataset.filterValue || '');
          if (!key || key.indexOf('::') === -1) return;
          var img = btn.querySelector('.cmgp-carousel-item__image');
          var pid = btn.getAttribute('data-carousel-product-id');
          if (!img || !img.src) {
            pending[key] = btn;
            return;
          }
          var sk = srcKey(img.src);
          if (seenSrcOwner[sk]) {
            pending[key] = btn;
            return;
          }
          seenSrcOwner[sk] = btn;
          markUsed(btn, pid, img.src);
        });

        var pendingKeys = function() { return Object.keys(pending); };
        if (!pendingKeys().length) return;

        var maxPages = 10; // 2500 products max scan
        function getProductTags(product) {
          return String(product.tags || '').split(',').map(function(t) { return norm(t.trim()); }).filter(Boolean);
        }

        function productMatches(product, filterParam, filterValueNorm) {
          if (!product || !filterValueNorm) return false;
          var ptype = norm(product.product_type || product.type || '');
          if (filterParam === 'filter.p.tag' || (filterParam.indexOf('filter.p.') === 0 && filterParam.indexOf('.tag') !== -1)) {
            var tags = getProductTags(product);
            if (tags.some(function(t) { return t === filterValueNorm; })) return true;
            return ptype === filterValueNorm;
          }
          return ptype === filterValueNorm;
        }

        function getProductImageSrc(product) {
          if (product.image && product.image.src) return product.image.src;
          if (product.images && product.images.length && product.images[0].src) return product.images[0].src;
          return '';
        }

        function pickBestProduct(products, filterParam, filterValueNorm) {
          var best = null;
          var bestScore = -1;
          for (var i = 0; i < products.length; i++) {
            var pr = products[i];
            if (!productMatches(pr, filterParam, filterValueNorm)) continue;
            if (pr.id && usedProductIds[String(pr.id)]) continue;
            var imgSrc = getProductImageSrc(pr);
            if (!imgSrc || usedImageSrcs[srcKey(imgSrc)]) continue;
            var tags = getProductTags(pr);
            var overlap = 0;
            for (var j = 0; j < carouselFilterTags.length; j++) {
              if (tags.indexOf(carouselFilterTags[j]) !== -1) overlap++;
            }
            var score = 1000 - (overlap * 10);
            if (tags.indexOf(filterValueNorm) !== -1) score += 5;
            if (score > bestScore) {
              bestScore = score;
              best = { product: pr, imgSrc: imgSrc };
            }
          }
          return best;
        }

        function applyImage(btn, src, productId) {
          if (!btn || !src) return;
          var imgWrap = btn.querySelector('.cmgp-carousel-item__img');
          if (!imgWrap) return;
          imgWrap.innerHTML = '';
          var img = document.createElement('img');
          img.className = 'cmgp-carousel-item__image';
          img.loading = 'lazy';
          img.alt = (btn.querySelector('.cmgp-carousel-item__title') || {}).textContent || '';
          img.src = src;
          imgWrap.appendChild(img);
          markUsed(btn, productId, src);
        }

        function finishUnmatchedPending() {
          if (typeof updateCarouselButtons === 'function') updateCarouselButtons();
        }

        function scanPage(page) {
          var url = '/collections/' + encodeURIComponent(collHandle) + '/products.json?limit=250&page=' + page;
          return fetch(url, { headers: { 'Accept': 'application/json' } })
            .then(function(r) { return r.ok ? r.json() : null; })
            .then(function(data) {
              var products = (data && data.products) ? data.products : [];
              if (!products.length && page === 1) {
                var pathMatch = (window.location.pathname || '').match(/\/collections\/([^/?#]+)/);
                if (pathMatch && pathMatch[1]) {
                  var altHandle = decodeURIComponent(pathMatch[1]);
                  if (altHandle && altHandle !== collHandle) {
                    var altUrl = '/collections/' + encodeURIComponent(altHandle) + '/products.json?limit=250&page=' + page;
                    return fetch(altUrl, { headers: { 'Accept': 'application/json' } })
                      .then(function(r2) { return r2.ok ? r2.json() : null; })
                      .then(function(altData) {
                        return altData && altData.products ? altData.products : [];
                      });
                  }
                }
              }
              return products;
            })
            .then(function(products) {
              if (!products || !products.length) {
                finishUnmatchedPending();
                return false;
              }

              pendingKeys().forEach(function(key) {
                var parts = key.split('::');
                var p = parts[0];
                var v = parts[1];
                var btn = pending[key];
                if (!btn) return;
                var match = pickBestProduct(products, p, v);
                if (!match) return;
                applyImage(btn, match.imgSrc, match.product.id);
                delete pending[key];
              });

              if (!pendingKeys().length) return true;
              if (products.length < 250) {
                finishUnmatchedPending();
                return true;
              }
              if (page >= maxPages) {
                finishUnmatchedPending();
                return true;
              }
              return scanPage(page + 1);
            })
            .catch(function() {
              finishUnmatchedPending();
              return true;
            });
        }

        scanPage(1);
      }

      var trackWrap = carousel ? carousel.querySelector('.cmgp-carousel-track-wrap') : null;
      function updateCarouselButtons() {
        if (!track) return;
        var canScroll = track.scrollWidth > track.clientWidth;
        var itemCount = items.length;
        var shouldCenter = itemCount <= 8 && !canScroll;
        if (trackWrap) trackWrap.classList.toggle('cmgp-carousel-track-wrap--centered', shouldCenter);
        if (prevBtn && nextBtn) {
          prevBtn.classList.toggle('cmgp-carousel-btn--hidden', !canScroll || track.scrollLeft <= 0);
          nextBtn.classList.toggle('cmgp-carousel-btn--hidden', !canScroll || track.scrollLeft >= track.scrollWidth - track.clientWidth - 2);
        }
      }
      if (track) {
        track.addEventListener('scroll', updateCarouselButtons);
        new ResizeObserver(updateCarouselButtons).observe(track);
      }
      if (track && prevBtn) prevBtn.addEventListener('click', function() { track.scrollBy({ left: -193, behavior: 'smooth' }); });
      if (track && nextBtn) nextBtn.addEventListener('click', function() { track.scrollBy({ left: 193, behavior: 'smooth' }); });
      updateCarouselButtons();
      ensureCarouselImagesFromAllPages();

      items.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var p = this.dataset.filterParam || 'filter.p.product_type';
          var v = this.dataset.filterValue;
          applyCarouselFilter(v, p, true);
        });
      });
      window.addEventListener('popstate', function() {
        updateCarouselActiveState();
        var popGrid = document.getElementById('cmgp-grid-' + sectionId);
        if (isServerFilteredGrid(popGrid)) {
          initGridForServerFiltered(popGrid);
          return;
        }
        if (typeof applyClientSideTypeFilter === 'function') applyClientSideTypeFilter();
        if (typeof autoLoadAllPagesIfFiltered === 'function') autoLoadAllPagesIfFiltered(null, { forceAll: true });
      });
    }
    
    if (!grid) return;
    
    const productsPerPage = parseInt(grid.dataset.productsPerPage) || 24;
    const totalProducts = parseInt(grid.dataset.totalProducts) || 0;
    
    /* Show/hide interleaved banners based on visible product count before each banner in DOM order. */
    function refreshGridBanners(gridEl) {
      if (!gridEl || !gridEl.children) return;
      var totalVisible = 0;
      gridEl.querySelectorAll('.cmgp-product-item').forEach(function(el) {
        if (el.style.display !== 'none') totalVisible++;
      });
      var visibleBefore = 0;
      var lastVisibleBannerIndex = -1;
      for (var i = 0; i < gridEl.children.length; i++) {
        var child = gridEl.children[i];
        if (child.classList && child.classList.contains('cmgp-product-item')) {
          if (child.style.display !== 'none') visibleBefore++;
          continue;
        }
        if (!child.classList || !child.classList.contains('cmgp-banner')) continue;
        var minProducts = parseInt(child.getAttribute('data-min-products'), 10) || 0;
        var isTop = child.getAttribute('data-banner-type') === 'top';
        var show;
        if (isTop) {
          show = totalVisible >= minProducts;
        } else {
          show = totalVisible >= minProducts && visibleBefore >= minProducts;
        }
        child.style.display = show ? 'block' : 'none';
        child.classList.remove('cmgp-banner-last');
        if (show) lastVisibleBannerIndex = i;
      }
      if (lastVisibleBannerIndex >= 0 && gridEl.children[lastVisibleBannerIndex]) {
        gridEl.children[lastVisibleBannerIndex].classList.add('cmgp-banner-last');
      }
    }

    function hideBannersAfterLastVisibleProduct(gridEl, afterLastMatchingIndex) {
      refreshGridBanners(gridEl);
    }

    function getProductIdFromGridItem(item) {
      if (!item) return '';
      var direct = item.getAttribute('data-product-id');
      if (direct) return String(direct);
      var btn = item.querySelector('[data-product-id]');
      return btn ? String(btn.getAttribute('data-product-id') || '') : '';
    }

    function dedupeGridProducts(gridEl) {
      if (!gridEl) return;
      var seen = {};
      gridEl.querySelectorAll('.cmgp-product-item').forEach(function(item) {
        var id = getProductIdFromGridItem(item);
        var key = id || (item.getAttribute('data-product-sku') || '').trim() || (item.getAttribute('data-product-index') || '').trim();
        if (!key) return;
        if (seen[key]) {
          item.remove();
          return;
        }
        seen[key] = true;
      });
    }

    function getGridProductIdSet(gridEl) {
      var set = {};
      if (!gridEl) return set;
      gridEl.querySelectorAll('.cmgp-product-item').forEach(function(item) {
        var id = getProductIdFromGridItem(item);
        if (id) set[id] = true;
      });
      return set;
    }

    function appendProductsFromResponseGrid(gridEl, responseGrid, opts) {
      opts = opts || {};
      if (!gridEl || !responseGrid) return [];
      var showAsFlex = opts.showAsFlex !== false;
      var existingIds = getGridProductIdSet(gridEl);
      var existingBannerKeys = {};
      gridEl.querySelectorAll('.cmgp-banner').forEach(function(b) {
        var key =
          (b.getAttribute('data-banner-type') || 'grid') +
          ':' +
          (b.getAttribute('data-banner-slot') || b.getAttribute('data-min-products') || '');
        existingBannerKeys[key] = true;
      });
      var appended = [];
      var bannerNodes = [];
      var productNodes = [];
      responseGrid.querySelectorAll('.cmgp-product-item, .cmgp-banner').forEach(function(node) {
        if (node.classList.contains('cmgp-banner')) {
          var bannerKey =
            (node.getAttribute('data-banner-type') || 'grid') +
            ':' +
            (node.getAttribute('data-banner-slot') || node.getAttribute('data-min-products') || '');
          if (existingBannerKeys[bannerKey]) return;
          existingBannerKeys[bannerKey] = true;
          node.style.display = 'none';
          bannerNodes.push(node);
          return;
        }
        var id = getProductIdFromGridItem(node);
        if (id && existingIds[id]) return;
        if (id) existingIds[id] = true;
        if (showAsFlex) node.style.display = 'flex';
        productNodes.push(node);
        appended.push(node);
      });

      bannerNodes.forEach(function(node) {
        gridEl.appendChild(node);
      });
      var fragment = document.createDocumentFragment();
      productNodes.forEach(function(node) {
        fragment.appendChild(node);
      });
      gridEl.appendChild(fragment);

      if (gridHasInterleavedBanners(gridEl) && appended.length && !shouldHideGridBanners(gridEl)) {
        var sortBy = getCurrentSortBy(gridEl);
        var compareFn = getProductComparator(sortBy);
        var products = Array.from(gridEl.querySelectorAll('.cmgp-product-item'));
        if (sortBy === 'manual' || !sortBy) {
          var pinnedOrderMap = getPinnedProductOrderMap(gridEl);
          var manualLimit = getManualPriorityLimit(gridEl);
          products = sortProductsWithManualPriority(products, compareFn, pinnedOrderMap, manualLimit);
        } else {
          products.sort(compareFn);
        }
        rebuildInterleavedGrid(gridEl, products);
      }

      return appended;
    }
    
    /* Carousel filter: one filter at a time. Product must match the active filter; others hidden. */
    var normFilter = function(v) { return (v || '').replace(/\+/g, ' ').toLowerCase().replace(/\s+/g, '-'); };
    function applyClientSideTypeFilter(optSearch) {
      var gridEl = document.getElementById('cmgp-grid-' + sectionId);
      if (!gridEl) return;
      if (isServerFilteredGrid(gridEl)) return;
      dedupeGridProducts(gridEl);
      var raw = optSearch !== undefined && optSearch !== null ? optSearch : ((wrapper && wrapper.ownerDocument && wrapper.ownerDocument.location && wrapper.ownerDocument.location.search) || (window.location && window.location.search) || '');
      var qStr = String(raw);
      if (qStr.charAt(0) === '?') qStr = qStr.slice(1);
      var q = new URLSearchParams(qStr);
      var norm = normFilter;
      var typeFilters = [];
      var tagFilters = [];
      q.forEach(function(val, key) {
        if (key === 'filter.p.tag' || (key.indexOf('filter.p.') === 0 && key.indexOf('.tag') !== -1)) {
          tagFilters.push(norm(val));
        } else if (key === 'filter.p.product_type' || (key.indexOf('filter.p.') === 0 && (key.indexOf('product_type') !== -1 || key.indexOf('custom.type') !== -1))) {
          typeFilters.push(norm(val));
        }
      });
      var hasCarouselFilters = typeFilters.length > 0 || tagFilters.length > 0;
      var hasBanners = gridHasInterleavedBanners(gridEl);
      var items = gridEl.querySelectorAll('.cmgp-product-item');
      var banners = gridEl.querySelectorAll('.cmgp-banner');
      var visibleCount = 0;
      items.forEach(function(el) {
        var type = norm(el.dataset.productType || '');
        var tagsStr = el.dataset.productTags || '';
        var tags = tagsStr ? tagsStr.split(',').map(function(t) { return norm(t.trim()); }).filter(Boolean) : [];
        var matchType = typeFilters.length === 0 || typeFilters.indexOf(type) !== -1;
        var tagMatchesFilter = function(tf, tagList) {
          if (!tf || !tagList.length) return false;
          for (var ti = 0; ti < tagList.length; ti++) {
            var th = tagList[ti];
            if (!th) continue;
            if (th === tf) return true;
            if (th + 's' === tf || th === tf + 's') return true;
            if (th.endsWith('s') && th.slice(0, -1) === tf) return true;
            if (tf.endsWith('s') && tf.slice(0, -1) === th) return true;
          }
          return false;
        };
        var matchTag = tagFilters.length === 0 || tagFilters.some(function(tf) { return tagMatchesFilter(tf, tags); });
        /* Tag filter: sirf tag se match, product type ka koi wasta nahi. Type filter alag hai. */
        var match = !hasCarouselFilters || (tagFilters.length > 0 ? matchTag : (typeFilters.length > 0 ? matchType : true));
        if (match) {
          el.style.display = 'flex';
          el.style.order = hasBanners ? '' : '0';
          visibleCount++;
        } else {
          el.style.display = 'none';
          el.style.order = hasBanners ? '' : '1';
        }
      });
      if (hasCarouselFilters) {
        gridEl.dataset.cmgpHideBanners = 'true';
      } else {
        gridEl.dataset.cmgpHideBanners = 'false';
      }
      var filterSearch = optSearch !== undefined && optSearch !== null ? optSearch : raw;
      applyProductOrdering(gridEl, {
        includeHidden: false,
        withoutBanners: shouldHideGridBanners(gridEl, filterSearch)
      });
      var carouselEl = document.getElementById('cmgp-carousel-' + sectionId);
      if (carouselEl) {
        carouselEl.querySelectorAll('.cmgp-carousel-item').forEach(function(btn) { btn.style.display = ''; });
      }
    }

    function getCurrentSortBy(gridEl) {
      if (gridEl && gridEl.dataset.sortBy) return gridEl.dataset.sortBy;
      var params = new URLSearchParams(window.location.search);
      return params.get('sort_by') || 'manual';
    }

    function getProductPrice(el) {
      var p = parseInt(el.getAttribute('data-price'), 10);
      return isNaN(p) ? 0 : p;
    }

    function getProductIndex(el) {
      var i = parseInt(el.getAttribute('data-product-index'), 10);
      return isNaN(i) ? 0 : i;
    }

    /* SKU DESC ordering + related grouping (default / Featured):
       Higher full SKU number first (e.g. 172854 before 168385).
       Same image-key products stay clustered inside each SKU bucket. */
    function extractSkuNumber(sku) {
      var s = String(sku || '').trim();
      var digits = s.replace(/\D/g, '');
      if (!digits) return 0;
      var n = parseInt(digits, 10);
      return isNaN(n) ? 0 : n;
    }

    function compareProductsBySku(a, b) {
      var aSku = a.getAttribute('data-product-sku') || '';
      var bSku = b.getAttribute('data-product-sku') || '';
      var aNum = extractSkuNumber(aSku);
      var bNum = extractSkuNumber(bSku);
      if (aNum !== bNum) return bNum - aNum;

      var aImg = (a.getAttribute('data-image-key') || '').toLowerCase();
      var bImg = (b.getAttribute('data-image-key') || '').toLowerCase();
      if (aImg !== bImg) return aImg.localeCompare(bImg);

      return bSku.localeCompare(aSku) * -1;
    }

    function compareProductsByPriceAsc(a, b) {
      var diff = getProductPrice(a) - getProductPrice(b);
      if (diff !== 0) return diff;
      return getProductIndex(a) - getProductIndex(b);
    }

    function compareProductsByPriceDesc(a, b) {
      var diff = getProductPrice(b) - getProductPrice(a);
      if (diff !== 0) return diff;
      return getProductIndex(a) - getProductIndex(b);
    }

    function compareProductsByServerIndex(a, b) {
      return getProductIndex(a) - getProductIndex(b);
    }

    function getProductComparator(sortBy) {
      if (sortBy === 'price-ascending') return compareProductsByPriceAsc;
      if (sortBy === 'price-descending') return compareProductsByPriceDesc;
      if (sortBy === 'manual' || !sortBy) return compareProductsBySku;
      return compareProductsByServerIndex;
    }

    function gridHasInterleavedBanners(gridEl) {
      return !!(gridEl && gridEl.querySelector('.cmgp-banner'));
    }

    /* Featured sort: first 16 manual picks, then SKU DESC for the rest. */
    function getPinnedProductOrderMap(gridEl) {
      if (!gridEl) return null;
      var raw = gridEl.getAttribute('data-pinned-product-ids') || '';
      if (!raw) return null;
      var ids = raw.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
      if (!ids.length) return null;
      var orderMap = {};
      ids.forEach(function(id, index) {
        orderMap[id] = index + 1;
      });
      return orderMap;
    }

    function getManualPriorityLimit(gridEl) {
      var n = parseInt(gridEl.getAttribute('data-manual-priority-count'), 10);
      return isNaN(n) || n < 1 ? 16 : n;
    }

    function sortProductsWithManualPriority(products, compareFn, pinnedOrderMap, manualLimit) {
      var hasPinned = !!(pinnedOrderMap && Object.keys(pinnedOrderMap).length);
      var priority = [];
      var rest = [];

      products.forEach(function(el) {
        var pid = el.getAttribute('data-product-id');
        var manualPos = parseInt(el.getAttribute('data-manual-position'), 10);
        var isThemePinned = hasPinned && pid && pinnedOrderMap[pid];
        var isManualTop = !hasPinned && !isNaN(manualPos) && manualPos >= 1 && manualPos <= manualLimit;

        if (isThemePinned || isManualTop) {
          priority.push(el);
        } else {
          rest.push(el);
        }
      });

      priority.sort(function(a, b) {
        var aPid = a.getAttribute('data-product-id');
        var bPid = b.getAttribute('data-product-id');
        if (hasPinned) {
          var ap = pinnedOrderMap[aPid] || 9999;
          var bp = pinnedOrderMap[bPid] || 9999;
          if (ap !== bp) return ap - bp;
        }
        var am = parseInt(a.getAttribute('data-manual-position'), 10) || 9999;
        var bm = parseInt(b.getAttribute('data-manual-position'), 10) || 9999;
        return am - bm;
      });

      rest.sort(compareFn);
      return priority.concat(rest);
    }

    function getGridColumns(gridEl) {
      var wrap = gridEl && gridEl.closest ? gridEl.closest('.collection-main-grid-premium') : null;
      if (wrap) {
        var fromVar = parseInt(getComputedStyle(wrap).getPropertyValue('--cmgp-products-per-row'), 10);
        if (fromVar > 0) return fromVar;
      }
      var fromData = parseInt(gridEl && gridEl.getAttribute('data-grid-columns'), 10);
      if (fromData > 0) return fromData;
      return 4;
    }

    function appendFullProductRow(fragment, sortedProducts, piRef, cols) {
      var placed = 0;
      for (var i = 0; i < cols && piRef.value < sortedProducts.length; i++) {
        fragment.appendChild(sortedProducts[piRef.value++]);
        placed++;
      }
      return placed;
    }

    function setBannerSideClass(banner, sideIndex) {
      if (!banner) return;
      banner.classList.remove('cmgp-banner-left', 'cmgp-banner-right');
      banner.classList.add(sideIndex % 2 === 0 ? 'cmgp-banner-left' : 'cmgp-banner-right');
    }

    function appendBannerRow(fragment, banner, sideIndex, sortedProducts, piRef, slotsWithProducts) {
      var pi = piRef.value;
      setBannerSideClass(banner, sideIndex);
      banner.style.display = 'block';
      var isLeft = sideIndex % 2 === 0;
      var placed = 0;
      if (isLeft) {
        fragment.appendChild(banner);
        for (var i = 0; i < slotsWithProducts && pi < sortedProducts.length; i++) {
          fragment.appendChild(sortedProducts[pi++]);
          placed++;
        }
      } else {
        for (var j = 0; j < slotsWithProducts && pi < sortedProducts.length; j++) {
          fragment.appendChild(sortedProducts[pi++]);
          placed++;
        }
        fragment.appendChild(banner);
      }
      piRef.value = pi;
      return placed;
    }

    function markLastVisibleGridBanner(gridEl) {
      if (!gridEl) return;
      var lastBanner = null;
      gridEl.querySelectorAll('.cmgp-banner').forEach(function(b) {
        b.classList.remove('cmgp-banner-last');
        if (b.style.display !== 'none') lastBanner = b;
      });
      if (lastBanner) lastBanner.classList.add('cmgp-banner-last');
    }

    function rebuildInterleavedGrid(gridEl, sortedProducts) {
      if (!gridEl || !sortedProducts) return;
      var cols = getGridColumns(gridEl);
      var slotsWithProducts = Math.max(cols - 1, 1);
      var allBanners = Array.from(gridEl.querySelectorAll('.cmgp-banner'));
      var topBanner = allBanners.find(function(b) {
        return b.getAttribute('data-banner-type') === 'top';
      });
      var gridBanners = allBanners
        .filter(function(b) {
          return b.getAttribute('data-banner-type') === 'grid';
        })
        .sort(function(a, b) {
          return (
            (parseInt(a.getAttribute('data-min-products'), 10) || 0) -
            (parseInt(b.getAttribute('data-min-products'), 10) || 0)
          );
        });

      var totalProducts = sortedProducts.length;
      var bannerQueue = [];
      if (topBanner) {
        var topMin = parseInt(topBanner.getAttribute('data-min-products'), 10) || 0;
        if (totalProducts >= topMin) bannerQueue.push(topBanner);
      }
      gridBanners.forEach(function(b) {
        var minP = parseInt(b.getAttribute('data-min-products'), 10) || 0;
        if (totalProducts >= minP) bannerQueue.push(b);
      });

      var frag = document.createDocumentFragment();
      var piRef = { value: 0 };
      var rowNum = 1;
      var bannerIdx = 0;
      var placedBanners = {};
      var maxRows = Math.max(bannerQueue.length * 2 + 20, Math.ceil(totalProducts / cols) + bannerQueue.length * 2);

      while (rowNum <= maxRows && (bannerIdx < bannerQueue.length || piRef.value < sortedProducts.length)) {
        var bannerRow = bannerIdx < bannerQueue.length ? 1 + bannerIdx * 2 : Infinity;

        if (rowNum === bannerRow) {
          appendBannerRow(frag, bannerQueue[bannerIdx], bannerIdx, sortedProducts, piRef, slotsWithProducts);
          placedBanners[bannerQueue[bannerIdx]] = true;
          bannerIdx++;
        } else if (piRef.value < sortedProducts.length) {
          appendFullProductRow(frag, sortedProducts, piRef, cols);
        } else {
          break;
        }
        rowNum++;
      }

      allBanners.forEach(function(b) {
        if (!placedBanners[b]) {
          b.style.display = 'none';
          frag.appendChild(b);
        }
      });

      while (gridEl.firstChild) {
        gridEl.removeChild(gridEl.firstChild);
      }
      gridEl.appendChild(frag);
      markLastVisibleGridBanner(gridEl);
    }

    function reorderProductsPreservingBanners(gridEl, sortedProducts) {
      rebuildInterleavedGrid(gridEl, sortedProducts);
    }

    function applyDomProductOrder(gridEl, sortedProducts, banners, options) {
      options = options || {};
      if (!gridEl || !sortedProducts.length) return;
      sortedProducts.forEach(function(el) {
        el.style.order = '';
      });
      var hideBanners = options.withoutBanners === true;
      if (gridHasInterleavedBanners(gridEl) && !hideBanners) {
        rebuildInterleavedGrid(gridEl, sortedProducts);
        return;
      }
      rebuildProductsOnlyGrid(gridEl, sortedProducts, options.hiddenProducts || []);
    }

    function applyProductOrdering(gridEl, options) {
      if (!gridEl) return;
      options = options || {};
      var includeHidden = options.includeHidden !== false;
      var withoutBanners =
        options.withoutBanners === true ||
        (options.withoutBanners !== false && shouldHideGridBanners(gridEl, options.optSearch));
      var sortBy = getCurrentSortBy(gridEl);
      var compareFn = getProductComparator(sortBy);

      var allProducts = Array.from(gridEl.querySelectorAll('.cmgp-product-item'));
      var products = includeHidden
        ? allProducts
        : allProducts.filter(function(el) { return el.style.display !== 'none'; });
      var hiddenProducts = includeHidden
        ? []
        : allProducts.filter(function(el) { return el.style.display === 'none'; });
      if (!products.length) {
        if (withoutBanners) {
          gridEl.querySelectorAll('.cmgp-banner').forEach(function(b) {
            b.style.display = 'none';
          });
        }
        return;
      }

      if (sortBy === 'manual' || !sortBy) {
        var pinnedOrderMap = getPinnedProductOrderMap(gridEl);
        var manualLimit = getManualPriorityLimit(gridEl);
        products = sortProductsWithManualPriority(products, compareFn, pinnedOrderMap, manualLimit);
      } else {
        products.sort(compareFn);
      }

      applyDomProductOrder(gridEl, products, [], {
        withoutBanners: withoutBanners,
        hiddenProducts: hiddenProducts
      });
    }

    function applySkuAndRelatedOrdering(gridEl, options) {
      applyProductOrdering(gridEl, options);
    }

    function getProductsSortedByCurrentOrder(gridEl, includeHidden) {
      var products = Array.from(gridEl.querySelectorAll('.cmgp-product-item'));
      if (!includeHidden) {
        products = products.filter(function(el) { return el.style.display !== 'none'; });
      }
      var domOrder = {};
      Array.from(gridEl.children).forEach(function(child, index) {
        if (child.classList.contains('cmgp-product-item')) {
          domOrder[child] = index;
        }
      });
      var sortBy = getCurrentSortBy(gridEl);
      var compareFn = getProductComparator(sortBy);
      products.sort(function(a, b) {
        var ao = domOrder[a];
        var bo = domOrder[b];
        if (ao !== undefined && bo !== undefined && ao !== bo) return ao - bo;
        return compareFn(a, b);
      });
      return products;
    }

    function getProductsSortedBySkuOrder(gridEl, includeHidden) {
      return getProductsSortedByCurrentOrder(gridEl, includeHidden);
    }

    function applyIncrementalSkuOrder(gridEl, newProductNodes) {
      if (!gridEl || !newProductNodes || !newProductNodes.length) return;
      newProductNodes.forEach(function(el) {
        el.style.display = 'flex';
      });
      applyProductOrdering(gridEl, { includeHidden: false });
    }

    function revealAllProductsInGrid(gridEl, optSearch) {
      if (!gridEl) return;
      gridEl.classList.add('cmgp-grid--bulk-append');
      try {
        var hideBanners = shouldHideGridBanners(gridEl, optSearch);
        gridEl.dataset.cmgpHideBanners = hideBanners ? 'true' : 'false';
        applyProductOrdering(gridEl, { includeHidden: true, withoutBanners: hideBanners, optSearch: optSearch });
        gridEl.querySelectorAll('.cmgp-product-item').forEach(function(el) {
          el.style.display = 'flex';
        });
        if (typeof applyClientSideTypeFilter === 'function') {
          applyClientSideTypeFilter(optSearch);
        } else if (!hideBanners) {
          hideBannersAfterLastVisibleProduct(gridEl);
        }
      } finally {
        gridEl.classList.remove('cmgp-grid--bulk-append');
      }
    }

    function initGridForServerFiltered(gridEl) {
      if (!gridEl) return;
      gridEl.dataset.cmgpHideBanners = 'true';
      gridEl.querySelectorAll('.cmgp-product-item').forEach(function(el) {
        if (el.style.display !== 'none') {
          el.style.display = 'flex';
        }
      });
      var products = Array.from(gridEl.querySelectorAll('.cmgp-product-item')).filter(function(el) {
        return el.style.display !== 'none';
      });
      if (products.length) {
        rebuildProductsOnlyGrid(gridEl, products);
      } else {
        gridEl.querySelectorAll('.cmgp-banner').forEach(function(b) {
          b.style.display = 'none';
        });
      }
    }

    function isServerFilteredGrid(gridEl) {
      if (gridEl && gridEl.dataset.serverFilters === 'true') return true;
      if (gridEl && gridEl.dataset.serverFilters === 'false') return false;
      return initialStorefrontFiltered;
    }

    function applyInitialClientPagination(gridEl, optSearch) {
      if (isServerFilteredGrid(gridEl)) {
        initGridForServerFiltered(gridEl);
        return;
      }
      revealAllProductsInGrid(gridEl, optSearch);
    }

    function hasCarouselFilterInUrl(optSearch) {
      var raw = optSearch !== undefined && optSearch !== null ? optSearch : (window.location && window.location.search) || '';
      var s = String(raw);
      if (s.charAt(0) === '?') s = s.slice(1);
      var q = new URLSearchParams(s);
      return !!(q.getAll('filter.p.tag').length || q.getAll('filter.p.product_type').length || q.getAll('filter.p.m.custom.type').length);
    }

    function shouldHideGridBanners(gridEl, optSearch) {
      if (isServerFilteredGrid(gridEl)) return true;
      if (hasCarouselFilterInUrl(optSearch)) return true;
      var raw = optSearch !== undefined && optSearch !== null ? optSearch : (window.location && window.location.search) || '';
      var s = String(raw);
      if (s.charAt(0) === '?') s = s.slice(1);
      var q = new URLSearchParams(s);
      var hide = false;
      q.forEach(function(val, key) {
        if (!val) return;
        if (key === 'sort_by' || key === 'page' || key === 'sections' || key === 'section_id') return;
        if (key === 'q') {
          hide = true;
          return;
        }
        if (key.indexOf('filter.') === 0) hide = true;
      });
      return hide;
    }

    function rebuildProductsOnlyGrid(gridEl, sortedProducts, hiddenProducts) {
      if (!gridEl || !sortedProducts) return;
      hiddenProducts = hiddenProducts || [];
      var cols = getGridColumns(gridEl);
      var frag = document.createDocumentFragment();
      var piRef = { value: 0 };
      while (piRef.value < sortedProducts.length) {
        appendFullProductRow(frag, sortedProducts, piRef, cols);
      }
      hiddenProducts.forEach(function(el) {
        el.style.display = 'none';
        frag.appendChild(el);
      });
      gridEl.querySelectorAll('.cmgp-banner').forEach(function(b) {
        b.style.display = 'none';
        b.classList.remove('cmgp-banner-last');
        frag.appendChild(b);
      });
      while (gridEl.firstChild) {
        gridEl.removeChild(gridEl.firstChild);
      }
      gridEl.appendChild(frag);
    }

    function autoLoadAllPagesIfFiltered(optSearch, loadOpts) {
      loadOpts = loadOpts || {};
      const gridEl = document.getElementById('cmgp-grid-' + sectionId);
      if (!gridEl) return Promise.resolve();
      /* Sidebar FILTER (?filter.*): Shopify already returned filtered HTML — no bulk AJAX. */
      if (isServerFilteredGrid(gridEl)) {
        initGridForServerFiltered(gridEl);
        gridEl.dataset.cmgpAllPagesLoaded = 'true';
        gridEl.dataset.cmgpPagesLoading = 'false';
        return Promise.resolve();
      }
      const useAjaxLoadMore = gridEl.dataset.useAjaxLoadMore === 'true';
      if (!useAjaxLoadMore) {
        if (isServerFilteredGrid(gridEl)) {
          initGridForServerFiltered(gridEl);
        } else {
          revealAllProductsInGrid(gridEl, optSearch);
        }
        return Promise.resolve();
      }
      if (gridEl.dataset.cmgpPagesLoading === 'true') return Promise.resolve();
      if (loadOpts.forceAll !== true && gridEl.dataset.cmgpAllPagesLoaded === 'true') {
        return Promise.resolve().then(function() {
          dedupeGridProducts(gridEl);
          if (typeof applyClientSideTypeFilter === 'function') applyClientSideTypeFilter(optSearch);
        });
      }
      gridEl.dataset.cmgpPagesLoading = 'true';

      const gridDomId = 'cmgp-grid-' + sectionId;
      const fetchOpts = { headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' } };

      function finalizePageLoad() {
        dedupeGridProducts(gridEl);
        if (isServerFilteredGrid(gridEl)) {
          initGridForServerFiltered(gridEl);
        } else {
          revealAllProductsInGrid(gridEl, optSearch);
        }
        if (typeof window.initCmgpCollectionDiscountPrices === 'function') {
          window.initCmgpCollectionDiscountPrices(gridEl || document);
        }
        if (typeof markWishlistActive === 'function') markWishlistActive();
      }

      function appendGridFromHtml(html) {
        if (!html) return null;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const responseGrid = doc.getElementById(gridDomId);
        if (!responseGrid) return null;
        if (responseGrid.dataset.sortBy) {
          gridEl.dataset.sortBy = responseGrid.dataset.sortBy;
        }
        appendProductsFromResponseGrid(gridEl, responseGrid, { showAsFlex: false });
        return {
          nextPageUrl: responseGrid.dataset.nextPageUrl || '',
          hasNext: responseGrid.dataset.hasNext || 'false',
          totalProducts: responseGrid.dataset.totalProducts || gridEl.dataset.totalProducts
        };
      }

      /* Pehle: har page ke baad filter = products batch‑batch dikhte the. Ab: jitni pages hon sab parallel fetch, phir ek hi dafa DOM merge + ek filter = tez + ek saath. */
      function sequentialFetchFallback() {
        function fetchNext() {
          const nextPageUrl = gridEl.dataset.nextPageUrl;
          if (!nextPageUrl || gridEl.dataset.hasNext !== 'true') {
            return Promise.resolve();
          }
          return fetch(nextPageUrl, fetchOpts)
            .then(function(r) { return r.text(); })
            .then(function(html) {
              const meta = appendGridFromHtml(html);
              if (meta) {
                if (typeof applyClientSideTypeFilter === 'function') applyClientSideTypeFilter(optSearch);
                gridEl.dataset.nextPageUrl = meta.nextPageUrl;
                gridEl.dataset.hasNext = meta.hasNext;
                gridEl.dataset.totalProducts = meta.totalProducts;
              } else {
                gridEl.dataset.hasNext = 'false';
                gridEl.dataset.nextPageUrl = '';
              }
            })
            .then(fetchNext)
            .catch(function() {
              gridEl.dataset.hasNext = 'false';
              gridEl.dataset.nextPageUrl = '';
            });
        }
        gridEl.classList.add('cmgp-grid--bulk-append');
        return fetchNext()
          .then(function() {
            gridEl.dataset.cmgpAllPagesLoaded = 'true';
            finalizePageLoad();
          })
          .finally(function() {
            gridEl.dataset.cmgpPagesLoading = 'false';
            gridEl.classList.remove('cmgp-grid--bulk-append');
          });
      }

      if (!gridEl.dataset.nextPageUrl || gridEl.dataset.hasNext !== 'true') {
        gridEl.dataset.cmgpAllPagesLoaded = 'true';
        return Promise.resolve().then(finalizePageLoad).finally(function() {
          gridEl.dataset.cmgpPagesLoading = 'false';
        });
      }

      const total = parseInt(gridEl.dataset.totalProducts, 10) || 0;
      const perPage = parseInt(gridEl.dataset.productsPerPage, 10) || 24;
      const totalPages = total > 0 && perPage > 0 ? Math.ceil(total / perPage) : 0;
      const nextRaw = gridEl.dataset.nextPageUrl;
      var startUrl = null;
      var startPage = 2;
      try {
        startUrl = new URL(nextRaw, window.location.origin);
        var pNum = parseInt(startUrl.searchParams.get('page') || '', 10);
        if (!isNaN(pNum) && pNum >= 2) startPage = pNum;
      } catch (e0) {
        startUrl = null;
      }

      var extraPages = totalPages > 0 && startPage > 0 ? (totalPages - startPage + 1) : 0;
      if (!startUrl || totalPages < 2 || extraPages < 1 || extraPages > 60) {
        return sequentialFetchFallback();
      }

      var pageJobs = [];
      for (var pg = startPage; pg <= totalPages; pg++) {
        var u = new URL(startUrl.href);
        u.searchParams.set('page', String(pg));
        pageJobs.push({ page: pg, url: u.pathname + u.search });
      }

      return Promise.all(pageJobs.map(function(job) {
        return fetch(job.url, fetchOpts)
          .then(function(r) { return r.ok ? r.text() : ''; })
          .then(function(html) { return { page: job.page, html: html }; });
      })).then(function(results) {
        results.sort(function(a, b) { return a.page - b.page; });
        gridEl.classList.add('cmgp-grid--bulk-append');
        try {
          for (var ri = 0; ri < results.length; ri++) {
            var meta = appendGridFromHtml(results[ri].html);
            if (meta && meta.totalProducts) gridEl.dataset.totalProducts = meta.totalProducts;
          }
          gridEl.dataset.hasNext = 'false';
          gridEl.dataset.nextPageUrl = '';
          gridEl.dataset.cmgpAllPagesLoaded = 'true';
        } finally {
          gridEl.classList.remove('cmgp-grid--bulk-append');
          gridEl.dataset.cmgpPagesLoading = 'false';
        }
        finalizePageLoad();
      }).catch(function() {
        gridEl.classList.remove('cmgp-grid--bulk-append');
        gridEl.dataset.cmgpPagesLoading = 'false';
        return sequentialFetchFallback();
      });
    }

    /* Carousel tag filter: Shopify sometimes returns empty HTML — reload unfiltered grid then filter client-side. */
    (function recoverEmptyGridWhenCarouselUrlFilter() {
      var gridEl = document.getElementById('cmgp-grid-' + sectionId);
      var rep = document.getElementById('cmgp-replaceable-content-' + sectionId);
      if (!gridEl || !rep || !wrapper) return;
      if (isServerFilteredGrid(gridEl)) return;
      if (!hasCarouselFilterInUrl()) return;
      if (gridEl.querySelectorAll('.cmgp-product-item').length > 0) return;
      var fetchUrlObj = new URL(window.location.href);
      ['filter.p.product_type', 'filter.p.tag', 'filter.p.m.custom.type'].forEach(function(p) {
        fetchUrlObj.searchParams.delete(p);
      });
      fetchUrlObj.searchParams.delete('sections');
      fetchUrlObj.searchParams.delete('section_id');
      var fq = fetchUrlObj.searchParams.toString();
      var fetchGo = fetchUrlObj.pathname + (fq ? '?' + fq : '');
      fetch(fetchGo, { headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextRep = doc.getElementById('cmgp-replaceable-content-' + sectionId);
          if (!nextRep) {
            return;
          }
          rep.innerHTML = nextRep.innerHTML;
          if (typeof window.initCmgpCollectionPricing === 'function') {
            window.initCmgpCollectionPricing(sectionId);
          }
          var replacedGrid = document.getElementById('cmgp-grid-' + sectionId);
          if (replacedGrid && typeof applyInitialClientPagination === 'function') applyInitialClientPagination(replacedGrid, window.location.search);
          if (typeof applyClientSideTypeFilter === 'function') applyClientSideTypeFilter(window.location.search);
          if (typeof markWishlistActive === 'function') markWishlistActive();
          var p = (typeof autoLoadAllPagesIfFiltered === 'function') ? autoLoadAllPagesIfFiltered() : Promise.resolve();
          return Promise.resolve(p).then(function() {
            if (typeof applyClientSideTypeFilter === 'function') applyClientSideTypeFilter();
          });
        })
        .catch(function() {});
    })();

    if (isServerFilteredGrid(grid)) {
      initGridForServerFiltered(grid);
      grid.dataset.cmgpAllPagesLoaded = 'true';
      grid.dataset.cmgpPagesLoading = 'false';
    } else {
      revealAllProductsInGrid(grid, window.location.search);
      autoLoadAllPagesIfFiltered(null, { forceAll: true });
    }
    
    // Wishlist Button Toggle (event delegation so it works after carousel filter replaces content)
    wrapper.addEventListener('click', function(e) {
      const btn = e.target.closest('.cmgp-wishlist-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      btn.classList.toggle('active');
      const productId = btn.dataset.productId;
      let wishlist = JSON.parse(localStorage.getItem('cmgp_wishlist') || '[]');
      if (btn.classList.contains('active')) {
        if (!wishlist.includes(productId)) wishlist.push(productId);
      } else {
        wishlist = wishlist.filter(function(id) { return id !== productId; });
      }
      localStorage.setItem('cmgp_wishlist', JSON.stringify(wishlist));
    });
    function markWishlistActive() {
      sectionRoot.querySelectorAll('.cmgp-wishlist-btn').forEach(function(btn) {
        const productId = btn.dataset.productId;
        if (productId && JSON.parse(localStorage.getItem('cmgp_wishlist') || '[]').indexOf(productId) !== -1) {
          btn.classList.add('active');
        }
      });
    }
    markWishlistActive();
    wrapper.addEventListener('cmgp-content-replaced', markWishlistActive);
    
    // Filter Dropdown Toggle (sidebar + overlay - dono par accordion)
    const filterGroups = sectionRoot.querySelectorAll('.cmgp-filter-group');
    filterGroups.forEach(function(group) {
      const title = group.querySelector('.cmgp-filter-title');
      if (title) {
        title.addEventListener('click', function() {
          group.classList.toggle('active');
        });
      }
    });
    
    // Sidebar filter form: submit so Shopify applies filters (price + checkboxes) correctly
    const filterForm = document.getElementById('cmgp-filter-form-' + sectionId);
    if (filterForm) {
      // Before submit: normalize price; inject hidden inputs for color group checkboxes (multiple variant values per group)
      filterForm.addEventListener('submit', function() {
        const minIn = document.getElementById('price-min-' + sectionId);
        const maxIn = document.getElementById('price-max-' + sectionId);
        [minIn, maxIn].forEach(function(inp) {
          if (!inp) return;
          if (!inp.dataset.paramName) inp.dataset.paramName = inp.getAttribute('name');
          var v = normalizePriceForFilter(inp.value);
          inp.value = v;
          if (v) inp.setAttribute('name', inp.dataset.paramName);
          else inp.removeAttribute('name');
        });
        filterForm.querySelectorAll('.cmgp-color-group-input').forEach(function(el) { el.remove(); });
        filterForm.querySelectorAll('.cmgp-color-group-checkbox:checked').forEach(function(cb) {
          var paramName = cb.getAttribute('data-param-name');
          var valuesStr = cb.getAttribute('data-variant-values') || '';
          if (!paramName || !valuesStr) return;
          valuesStr.split(',,,').forEach(function(val) {
            if (!val) return;
            var hid = document.createElement('input');
            hid.type = 'hidden';
            hid.name = paramName;
            hid.value = val.trim();
            hid.className = 'cmgp-color-group-input';
            filterForm.appendChild(hid);
          });
        });
      });
      // Checkbox change: submit form so only selected filters (and price range) apply
      const filterCheckboxes = document.querySelectorAll('#cmgp-sidebar-' + sectionId + ' input[type=checkbox]');
      filterCheckboxes.forEach(function(checkbox) {
        checkbox.addEventListener('change', function() {
          filterForm.submit();
        });
      });
    }
    
    // Apply price filter to grid (show/hide by data-price in cents) + update URL
    function applyPriceFilter(sectionId, minDollars, maxDollars) {
      const grid = document.getElementById('cmgp-grid-' + sectionId);
      if (!grid) return;
      const minCents = Math.round(parseFloat(minDollars) * 100) || 0;
      const maxCents = Math.round(parseFloat(maxDollars) * 100) || 999999999;
      grid.querySelectorAll('.cmgp-product-item').forEach(function(item) {
        const price = parseInt(item.dataset.price, 10) || 0;
        item.style.display = (price >= minCents && price <= maxCents) ? '' : 'none';
      });
      hideBannersAfterLastVisibleProduct(grid);
    }
    function updatePriceFill(container) {
      if (!container) return;
      const wrap = container.querySelector('.cmgp-price-range-slider-wrap');
      const fill = wrap && wrap.querySelector('.cmgp-price-range-fill');
      const sliderMin = container.querySelector('.cmgp-price-slider-min');
      const sliderMax = container.querySelector('.cmgp-price-slider-max');
      if (!fill || !sliderMin || !sliderMax) return;
      const maxCap = parseFloat(container.dataset.priceMax) || 10000;
      var minVal = parseFloat(sliderMin.value) || 0;
      var maxVal = parseFloat(sliderMax.value) || maxCap;
      if (minVal > maxVal) maxVal = minVal;
      var left = maxCap > 0 ? (minVal / maxCap) * 100 : 0;
      var width = maxCap > 0 ? ((maxVal - minVal) / maxCap) * 100 : 100;
      fill.style.setProperty('--fill-left', left + '%');
      fill.style.setProperty('--fill-width', width + '%');
    }
    function applyPriceFilterFromContainer(container) {
      if (!container) return;
      const sid = container.dataset.sectionId || sectionId;
      const priceGrid = document.getElementById('cmgp-grid-' + sid);
      if (isServerFilteredGrid(priceGrid)) return;
      const inputs = container.querySelectorAll('.cmgp-price-range-inputs input[type="number"]');
      const numMin = inputs[0];
      const numMax = inputs[1];
      if (!sid || !numMin || !numMax) return;
      var minD = parseFloat(numMin.value) || 0;
      var maxD = parseFloat(numMax.value) || 100000;
      if (minD > maxD) maxD = minD;
      applyPriceFilter(sid, minD, maxD);
      var urlSel = container.closest('.cmgp-filter-overlay') ? '#cmgp-filter-overlay-' + sid + ' .cmgp-filter-overlay-content' : '#cmgp-sidebar-' + sid;
      var url = buildFilterUrl(sid, urlSel);
      if (url && window.history && window.history.pushState) {
        try { window.history.pushState({}, '', url); } catch (e) {}
      }
    }
    function onPriceChange(container) {
      updatePriceFill(container);
      var priceGrid = document.getElementById('cmgp-grid-' + sectionId);
      if (isServerFilteredGrid(priceGrid)) return;
      applyPriceFilterFromContainer(container);
    }
    // Price range: sync sliders with inputs + fill bar + auto price filter
    function initPriceRangeSync(container) {
      if (!container) return;
      const wrap = container.querySelector('.cmgp-price-range-slider-wrap');
      const sliderMin = container.querySelector('.cmgp-price-slider-min');
      const sliderMax = container.querySelector('.cmgp-price-slider-max');
      const inputs = container.querySelectorAll('.cmgp-price-range-inputs input[type="number"]');
      const numMin = inputs[0];
      const numMax = inputs[1];
      if (!sliderMin || !sliderMax || !numMin || !numMax) return;
      const maxCap = parseInt(container.dataset.priceMax, 10) || 100000;
      function toNum(v) { var n = parseFloat(String(v).replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : Math.max(0, Math.min(maxCap, n)); }
      function syncMinToInput() {
        var v = toNum(sliderMin.value);
        numMin.value = Math.round(v);
        if (v > toNum(numMax.value)) { numMax.value = Math.round(v); sliderMax.value = v; }
        onPriceChange(container);
      }
      function syncMaxToInput() {
        var v = toNum(sliderMax.value);
        numMax.value = Math.round(v);
        if (v < toNum(numMin.value)) { numMin.value = Math.round(v); sliderMin.value = v; }
        onPriceChange(container);
      }
      function syncInputMinToSlider() {
        var v = toNum(numMin.value);
        sliderMin.value = v;
        if (v > toNum(numMax.value)) { numMax.value = Math.round(v); sliderMax.value = v; }
        onPriceChange(container);
      }
      function syncInputMaxToSlider() {
        var v = toNum(numMax.value);
        sliderMax.value = v;
        if (v < toNum(numMin.value)) { numMin.value = Math.round(v); sliderMin.value = v; }
        onPriceChange(container);
      }
      sliderMin.addEventListener('input', syncMinToInput);
      sliderMax.addEventListener('input', syncMaxToInput);
      numMin.addEventListener('input', syncInputMinToSlider);
      numMin.addEventListener('change', syncInputMinToSlider);
      numMax.addEventListener('input', syncInputMaxToSlider);
      numMax.addEventListener('change', syncInputMaxToSlider);
      updatePriceFill(container);
    }
    const sidebarPriceRange = document.querySelector('#cmgp-sidebar-' + sectionId + ' .cmgp-price-range');
    const overlayPriceRange = document.querySelector('#cmgp-filter-overlay-' + sectionId + ' .cmgp-price-range');
    initPriceRangeSync(sidebarPriceRange);
    initPriceRangeSync(overlayPriceRange);
    (function() {
      if (isServerFilteredGrid(grid)) return;
      var q = window.location.search || '';
      var hasPriceFilter = q.indexOf('filter.v.price') !== -1 || q.indexOf('filter%2Ev%2Eprice') !== -1;
      if (hasPriceFilter) {
        applyPriceFilterFromContainer(sidebarPriceRange || overlayPriceRange);
      }
    })();
    
    // Filter open (desktop button + mobile toggle) + Overlay Apply
    const filterBackdrop = document.getElementById('cmgp-filter-backdrop-' + sectionId);
    const overlayApplyBtn = document.getElementById('cmgp-overlay-apply-' + sectionId);
    if (filterOverlay) {
      function openFilterDrawer() {
        var scrollY = window.scrollY || window.pageYOffset;
        filterOverlay.classList.add('active');
        var scrollbarWidth = (window.innerWidth - document.documentElement.clientWidth) || 0;
        if (scrollbarWidth > 0) {
          document.body.style.setProperty('padding-right', scrollbarWidth + 'px', 'important');
        }
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        filterOverlay.dataset.scrollY = scrollY;
      }
      function closeFilterDrawer() {
        filterOverlay.classList.add('closing');
        filterOverlay.classList.remove('active');
        document.body.style.removeProperty('padding-right');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        setTimeout(function() {
          filterOverlay.classList.remove('closing');
          filterOverlay.dataset.scrollY = '';
        }, 350);
      }
      /* Desktop FILTER lives inside cmgp-replaceable-content; carousel category clicks replace that HTML,
         so the button must use delegation (same idea as load-more on wrapper). */
      wrapper.addEventListener('click', function(e) {
        if (!e.target.closest('#cmgp-filter-open-' + sectionId)) return;
        e.preventDefault();
        openFilterDrawer();
      });
      if (filterToggle) {
        filterToggle.addEventListener('click', openFilterDrawer);
      }
      if (filterClose) {
        filterClose.addEventListener('click', closeFilterDrawer);
      }
      if (filterBackdrop) {
        filterBackdrop.addEventListener('click', closeFilterDrawer);
      }
      if (overlayApplyBtn) {
        overlayApplyBtn.addEventListener('click', function() {
          applyFiltersFromOverlay(sectionId);
        });
      }
      filterOverlay.addEventListener('click', function(e) {
        if (e.target === filterOverlay) {
          closeFilterDrawer();
        }
      });
    }
    
    function updateCmgpCardPrice(card, saleLabel, compareLabel) {
      const wrap = card && card.querySelector('[data-cmgp-price-wrap]');
      if (!wrap || !saleLabel) return;
      if (!wrap.dataset.originalPriceHtml) {
        wrap.dataset.originalPriceHtml = wrap.innerHTML;
      }
      let saleEl = wrap.querySelector('[data-cmgp-sale-price]');
      if (!saleEl) return;
      let compareEl = wrap.querySelector('[data-cmgp-compare-price]');
      if (compareLabel) {
        wrap.classList.add('cmgp-product-price--on-sale');
        if (!compareEl) {
          compareEl = document.createElement('span');
          compareEl.className = 'cmgp-price-compare';
          compareEl.setAttribute('data-cmgp-compare-price', '');
          wrap.insertBefore(compareEl, saleEl);
        }
        compareEl.textContent = compareLabel;
        compareEl.hidden = false;
        saleEl.classList.add('cmgp-price-sale');
      } else {
        wrap.classList.remove('cmgp-product-price--on-sale');
        if (compareEl) compareEl.remove();
        saleEl = wrap.querySelector('[data-cmgp-sale-price]');
        if (saleEl) saleEl.classList.remove('cmgp-price-sale');
      }
      if (saleEl) saleEl.textContent = saleLabel;
    }

    function restoreCmgpCardPrice(card) {
      const wrap = card && card.querySelector('[data-cmgp-price-wrap]');
      if (wrap && wrap.dataset.originalPriceHtml) {
        wrap.innerHTML = wrap.dataset.originalPriceHtml;
      }
    }

    function cmgpApplySaleToWrap(wrap, saleCents, compareCents) {
      if (!wrap) return;
      var card = wrap.closest('.cmgp-product-card');
      var compareLabel = (compareCents && compareCents > saleCents) ? cmgpFormatMoney(compareCents) : '';
      updateCmgpCardPrice(card, cmgpFormatMoney(saleCents), compareLabel);
      wrap.setAttribute('data-on-sale', 'true');
      wrap.setAttribute('data-sale-cents', String(saleCents));
      if (compareCents) wrap.setAttribute('data-compare-cents', String(compareCents));
    }

    function applyCmgpPriceFromVariantJson(card) {
      var dataEl = card.querySelector('[data-cmgp-variant-prices]');
      if (!dataEl) return false;
      var list;
      var best = null;
      try { list = JSON.parse(dataEl.getAttribute('data-cmgp-variant-prices') || '[]'); } catch (e) { return false; }
      if (!list || !list.length) return false;
      list.forEach(function(v) {
        if (v.c > v.p && (!best || v.p < best.p)) best = v;
      });
      if (!best) return false;
      var wrap = card.querySelector('[data-cmgp-price-wrap]');
      if (!wrap) return false;
      cmgpApplySaleToWrap(wrap, best.p, best.c);
      return true;
    }

    function pumpCmgpCartPricingQueue() {
      while (cmgpCartPricingActive < CMGP_CART_PRICING_MAX && cmgpCartPricingQueue.length) {
        var job = cmgpCartPricingQueue.shift();
        cmgpCartPricingActive++;
        cmgpFetchVariantCartPricing(job.variantId).then(function(pricing) {
          if (pricing && pricing.onSale && job.wrap) {
            cmgpApplySaleToWrap(job.wrap, pricing.final, pricing.original);
          }
        }).finally(function() {
          cmgpCartPricingActive--;
          pumpCmgpCartPricingQueue();
        });
      }
    }

    function initCmgpCollectionPricing(gridSectionId) {
      var grid = document.getElementById('cmgp-grid-' + gridSectionId);
      if (typeof window.initCmgpCollectionDiscountPrices === 'function') {
        window.initCmgpCollectionDiscountPrices(grid || document);
        return;
      }
      var cards = document.querySelectorAll('#cmgp-grid-' + gridSectionId + ' .cmgp-product-card');
      cards.forEach(function(card) {
        if (card.dataset.cmgpPriceDone === '1') return;
        card.dataset.cmgpPriceDone = '1';
        if (applyCmgpPriceFromVariantJson(card)) return;
        var wrap = card.querySelector('[data-cmgp-price-wrap]');
        if (!wrap) return;
        if (wrap.getAttribute('data-on-sale') === 'true') return;
        var variantId = Number(wrap.getAttribute('data-variant-id'));
        if (!variantId) return;
        cmgpCartPricingQueue.push({ variantId: variantId, wrap: wrap });
      });
      pumpCmgpCartPricingQueue();
    }
    window.initCmgpCollectionPricing = initCmgpCollectionPricing;

    // Variant Swatch Hover - Change Product Image + price
    const variantSwatches = document.querySelectorAll('#cmgp-grid-' + sectionId + ' .cmgp-swatch');
    
    // Store original images on page load first
    document.querySelectorAll('#cmgp-grid-' + sectionId + ' .cmgp-product-card').forEach(function(card) {
      const primaryImage = card.querySelector('.cmgp-image-primary');
      if (primaryImage && !card.dataset.originalImage) {
        card.dataset.originalImage = primaryImage.src;
        card.dataset.originalSrcset = primaryImage.srcset || '';
      }
      if (primaryImage && !primaryImage.dataset.cmgpErrorBound) {
        primaryImage.dataset.cmgpErrorBound = '1';
        primaryImage.addEventListener('error', function() {
          if (card.dataset.originalImage && primaryImage.src !== card.dataset.originalImage) {
            primaryImage.src = card.dataset.originalImage;
            if (card.dataset.originalSrcset) primaryImage.srcset = card.dataset.originalSrcset;
          }
        });
      }
      const priceWrap = card.querySelector('[data-cmgp-price-wrap]');
      if (priceWrap && !priceWrap.dataset.originalPriceHtml) {
        priceWrap.dataset.originalPriceHtml = priceWrap.innerHTML;
      }
    });
    
    variantSwatches.forEach(function(swatch) {
      const variantImageUrl = swatch.dataset.variantImage;
      const variantId = swatch.dataset.variantId;
      const productUrl = swatch.dataset.productUrl;
      const productCard = swatch.closest('.cmgp-product-card');
      
      if (!productCard) return;
      
      const primaryImage = productCard.querySelector('.cmgp-image-primary');
      const secondaryImage = productCard.querySelector('.cmgp-image-secondary');
      const productLink = productCard.querySelector('.cmgp-product-link');
      
      // Check if we have variant image URL
      if (!variantImageUrl || variantImageUrl.trim() === '' || !primaryImage) {
        // If no variant image, skip this swatch
        return;
      }
      
      const salePriceLabel = swatch.dataset.salePrice || '';
      const comparePriceLabel = swatch.dataset.comparePrice || '';

      // Hover: Change image immediately
      swatch.addEventListener('mouseenter', function(e) {
        e.stopPropagation();

        if (salePriceLabel) {
          updateCmgpCardPrice(productCard, salePriceLabel, comparePriceLabel);
        }
        
        if (primaryImage && variantImageUrl && variantImageUrl.trim() !== '') {
          // Store original image on first hover
          if (!productCard.dataset.originalImage) {
            productCard.dataset.originalImage = primaryImage.src;
            productCard.dataset.originalSrcset = primaryImage.srcset || '';
          }
          
          // Change image immediately
          primaryImage.src = variantImageUrl;
          primaryImage.srcset = '';
          primaryImage.style.opacity = '1';
          primaryImage.style.display = 'block';
          primaryImage.classList.add('has-secondary');
          
          // Hide secondary image if it exists (we're showing variant image instead)
          if (secondaryImage) {
            secondaryImage.style.opacity = '0';
            secondaryImage.style.pointerEvents = 'none';
            secondaryImage.style.zIndex = '0';
          }
          
          // Make sure primary is on top
          primaryImage.style.zIndex = '3';
        }
      });
      
      // Mouse leave: Restore original image
      swatch.addEventListener('mouseleave', function(e) {
        e.stopPropagation();

        restoreCmgpCardPrice(productCard);
        
        if (primaryImage && productCard.dataset.originalImage) {
          primaryImage.src = productCard.dataset.originalImage;
          if (productCard.dataset.originalSrcset) {
            primaryImage.srcset = productCard.dataset.originalSrcset;
          }
          primaryImage.style.opacity = '';
          primaryImage.style.display = '';
          primaryImage.style.zIndex = '';
          
          // Show secondary image again if it exists (for normal hover)
          if (secondaryImage) {
            secondaryImage.style.opacity = '';
            secondaryImage.style.pointerEvents = '';
            secondaryImage.style.zIndex = '';
          }
        }
      });
      
      // Click: Update product URL with variant parameter
      swatch.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (productLink && variantId) {
          const url = new URL(productUrl, window.location.origin);
          url.searchParams.set('variant', variantId);
          window.location.href = url.toString();
        } else if (productLink) {
          window.location.href = productUrl;
        }
      });
      
      // Make swatch cursor pointer
      swatch.style.cursor = 'pointer';
    });
    
    window.cmgpGridApi = window.cmgpGridApi || {};
    window.cmgpGridApi[sectionId] = {
      applyClientFilter: function(optSearch) {
        if (typeof applyClientSideTypeFilter === 'function') applyClientSideTypeFilter(optSearch);
      },
      loadAllPages: function(optSearch, loadOpts) {
        if (typeof autoLoadAllPagesIfFiltered === 'function') {
          return Promise.resolve(autoLoadAllPagesIfFiltered(optSearch, loadOpts));
        }
        return Promise.resolve();
      },
      dedupeProducts: function() {
        var gridEl = document.getElementById('cmgp-grid-' + sectionId);
        dedupeGridProducts(gridEl);
      }
    };

    // Sort: select is inside replaceable content — delegation so it works after category carousel AJAX
    wrapper.addEventListener('change', function(e) {
      var t = e.target;
      if (!t || t.id !== 'cmgp-sort-' + sectionId) return;
      if (t.value) window.location.href = t.value;
    });

  // Normalize price for Shopify URL: shop expects "5" or "20.40" (decimal dot, no thousands comma)
  function normalizePriceForFilter(val) {
    if (!val || typeof val !== 'string') return '';
    var s = val.trim().replace(/\s/g, '');
    if (!s) return '';
    // If comma used as decimal (e.g. 20,40) replace with dot
    if (/^\d+,\d*$/.test(s) || /^\d*,\d+$/.test(s)) {
      s = s.replace(',', '.');
    }
    // Remove thousands separators (commas)
    s = s.replace(/,/g, '');
    var num = parseFloat(s);
    if (isNaN(num) || num < 0) return '';
    return String(num);
  }

  // Apply Price Filter (uses actual param names from Shopify inputs; preserves other filters)
  function applyPriceFilter(sectionId) {
    const minInput = document.getElementById('price-min-' + sectionId);
    const maxInput = document.getElementById('price-max-' + sectionId);
    if (!minInput || !maxInput) return;
    const minValue = normalizePriceForFilter(minInput.value);
    const maxValue = normalizePriceForFilter(maxInput.value);
    const minParamName = minInput.getAttribute('name');
    const maxParamName = maxInput.getAttribute('name');
    if (!minParamName || !maxParamName) return;

    const url = new URL(window.location.href);
    if (minValue) {
      url.searchParams.set(minParamName, minValue);
    } else {
      url.searchParams.delete(minParamName);
    }
    if (maxValue) {
      url.searchParams.set(maxParamName, maxValue);
    } else {
      url.searchParams.delete(maxParamName);
    }
    window.location.href = url.toString();
  }

  // Build filter URL from a container (sidebar or overlay): checkboxes + price inputs
  function buildFilterUrl(sectionId, containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return null;
    const url = new URL(window.location.href);

    // Remove existing filter params (collect keys first to avoid iteration issues)
    const keysToDelete = [];
    url.searchParams.forEach(function(value, key) {
      if (key.startsWith('filter.')) keysToDelete.push(key);
    });
    keysToDelete.forEach(function(key) { url.searchParams.delete(key); });

    // Add checked checkboxes (list + category filters)
    const checkboxes = container.querySelectorAll('input[type="checkbox"]:checked');
    checkboxes.forEach(function(checkbox) {
      if (checkbox.classList.contains('cmgp-color-group-checkbox')) return;
      const name = checkbox.getAttribute('name');
      const value = checkbox.value;
      if (name && value) {
        url.searchParams.append(name, value);
      }
    });
    // Color group: one checkbox = multiple variant values (e.g. Yellow Gold -> 14k-yellow-gold, 18k-yellow-gold)
    container.querySelectorAll('.cmgp-color-group-checkbox:checked').forEach(function(cb) {
      const paramName = cb.getAttribute('data-param-name');
      const valuesStr = cb.getAttribute('data-variant-values') || '';
      if (!paramName || !valuesStr) return;
      valuesStr.split(',,,').forEach(function(val) {
        if (val) url.searchParams.append(paramName, val.trim());
      });
    });

    // Add price filter if inputs exist and have values (normalized for Shopify: e.g. "100" or "100.50")
    const minInput = container.querySelector('input[id="price-min-' + sectionId + '"], input[id^="price-min-overlay-"]');
    const maxInput = container.querySelector('input[id="price-max-' + sectionId + '"], input[id^="price-max-overlay-"]');
    if (minInput) {
      const minParam = minInput.getAttribute('name');
      const minVal = normalizePriceForFilter(minInput.value);
      if (minParam) {
        if (minVal) url.searchParams.set(minParam, minVal);
        else url.searchParams.delete(minParam);
      }
    }
    if (maxInput) {
      const maxParam = maxInput.getAttribute('name');
      const maxVal = normalizePriceForFilter(maxInput.value);
      if (maxParam) {
        if (maxVal) url.searchParams.set(maxParam, maxVal);
        else url.searchParams.delete(maxParam);
      }
    }

    return url.toString();
  }

  // Apply Filters (sidebar: checkboxes + price; preserves price when checkbox changes)
  function applyFilters(sectionId) {
    const url = buildFilterUrl(sectionId, '#cmgp-sidebar-' + sectionId);
    if (url) window.location.href = url;
  }

  // Apply filters from mobile overlay and close overlay
  function applyFiltersFromOverlay(sectionId) {
    const url = buildFilterUrl(sectionId, '#cmgp-filter-overlay-' + sectionId + ' .cmgp-filter-overlay-content');
    if (url) {
      window.location.href = url;
    } else {
      const overlay = document.getElementById('cmgp-filter-overlay-' + sectionId);
      if (overlay) {
        var scrollY = parseInt(overlay.dataset.scrollY || '0', 10);
        overlay.style.setProperty('display', 'none', 'important');
        overlay.classList.add('closing');
        document.body.style.removeProperty('padding-right');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        setTimeout(function() {
          overlay.style.removeProperty('display');
          overlay.classList.remove('active', 'closing');
          overlay.dataset.scrollY = '';
          if (scrollY) requestAnimationFrame(function() { window.scrollTo(0, scrollY); });
        }, 0);
      }
    }
  }

  initCmgpCollectionPricing(sectionId);

  window.initCollectionMainGridPremium = function(targetSectionId) {
    var sid = targetSectionId || sectionId;
    var root = document.getElementById('cmgp-' + sid);
    var gridEl = document.getElementById('cmgp-grid-' + sid);
    if (gridEl) {
      if (isServerFilteredGrid(gridEl)) {
        initGridForServerFiltered(gridEl);
        gridEl.dataset.cmgpAllPagesLoaded = 'true';
        gridEl.dataset.cmgpPagesLoading = 'false';
      } else {
        applyInitialClientPagination(gridEl, window.location.search);
        applyClientSideTypeFilter(window.location.search);
        if (typeof autoLoadAllPagesIfFiltered === 'function') {
          autoLoadAllPagesIfFiltered(null, { forceAll: true });
        }
      }
      if (typeof markWishlistActive === 'function') markWishlistActive();
    }
    initCmgpCollectionPricing(sid);
    if (root) {
      root.dispatchEvent(new CustomEvent('cmgp-content-replaced', { bubbles: true }));
    }
  };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { bootCollectionGrid(0); });
  } else {
    bootCollectionGrid(0);
  }
  document.addEventListener('shopify:section:load', function(evt) {
    if (!evt.target) return;
    evt.target.querySelectorAll('.collection-main-grid-premium[data-section-id]').forEach(function(root) {
      if (!isGridSectionRoot(root)) return;
      var sid = root.getAttribute('data-section-id');
      root.dataset.cmgpBooted = '';
      if (sid && window.__cmgpGridBooted) delete window.__cmgpGridBooted[sid];
    });
    bootCollectionGrid(0);
  });
})();
